import { ToggleSwitch } from '@youseedk/dna-react';
import { worker, workerOptions } from 'mocks/browser';
import React, { useEffect, useState } from 'react';
import { useStorage } from 'shared/hooks/useStorage';
import { localStorageItems } from 'utils/constants/localStorage';
import { identity } from 'utils/identity';

const startWorker = async () => worker.start(workerOptions);

export function MockToggle() {
  const [mockActive, setMockActive] = useStorage<boolean>(localStorageItems.enableMsw, true);
  const [workerStarted, setWorkerStarted] = useState<boolean>(false);

  useEffect(() => {
    //@ts-ignore
    window.userId = identity.userId;
  }, []);

  useEffect(() => {
    (async () => {
      if (mockActive && !workerStarted) {
        await startWorker();
        setWorkerStarted(true);
      } else if (!mockActive && workerStarted) {
        worker.stop();
        setWorkerStarted(false);
      }
    })();
    return () => {
      worker.resetHandlers();
    };
  }, [mockActive, workerStarted]);

  const toggleMock = () => {
    setMockActive(!mockActive);
    // we should invalidate all react queries but we can't access the queryClient here
    window.location.reload();
  };

  return (
    <div className='navpanel__item-link'>
      <ToggleSwitch
        label='Use Mock Data'
        checked={Boolean(mockActive)}
        onChange={() => toggleMock()}
      />
    </div>
  );
}
